// @flow
import { entityReducer } from "src/utils/reducerUtils";
import TrendModel from "src/models/TrendModel";

export const seriesTrends = entityReducer({
  name: "seriesTrends",
  Model: TrendModel
});
